import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { ISubSection } from 'homepage/types/Feed';

/**
 * [getSearchLandingFeedSubSectionTrackingInfo]
 * All of the tracking events for homepage content require these 5 attributes.
 * They're passed down into each section, so we can fire events from deeper down in the tree. (ported from old goat.com)
 *
 * @param   {Object} moduleTrackingData        The base tracking data of the section the subsection is in
 * @param   {Number} subsection                the current subsection
 * @param   {Number} sectionSubsectionPosition Position of subsection in list, starting at 0
 * @returns {Object}
 */

export const getSearchLandingFeedSubSectionTrackingInfo = (
  moduleTrackingData: IModuleTrackingData,
  subsection: ISubSection,
  subsectionIndex: number,
) => {
  const collectionAttr = { collection_id: null, collection_slug: null };

  if (subsection?.searchConfig?.collectionId) {
    collectionAttr.collection_id = subsection?.searchConfig?.collectionId;
    collectionAttr.collection_slug = subsection?.searchConfig?.collectionId;
  } else if (!subsection?.searchConfig?.collectionId) {
    collectionAttr.collection_id = `${subsection?.searchConfig?.filterKey}/${subsection?.searchConfig?.filterValue}`;
    collectionAttr.collection_slug = `${subsection?.searchConfig?.filterKey}/${subsection?.searchConfig?.filterValue}`;
  }
  return {
    ...moduleTrackingData,
    sub_section_id: subsection?.uuid || String(subsection?.id),
    sub_section_position: subsectionIndex,
    sub_section_type: subsection?.type,
    sub_section_name: subsection?.title || subsection?.value,
    ...collectionAttr,
  };
};
